import React from "react";
import { Chord } from "../../model/core";
import { RydFloatingPanel } from "../widgets/RydFloatingPanel";
import { ChordSelectionDialog } from "../pickers/ChordSelectionDialog";


export function ChordInputFloatingDialog({
    chordSelectorRefEl,
    chord,
    setChordSelectorRefEl,
    updateChordCB
}: {
    chordSelectorRefEl: EventTarget & HTMLElement,
    chord?: Chord
    setChordSelectorRefEl: (el: EventTarget & HTMLElement | undefined) => void,
    updateChordCB?: (chord?: Chord) => void
}) {
    return (<RydFloatingPanel
        referenceElement={chordSelectorRefEl}
        offsetX={10}
        offsetY={10}>
        <ChordSelectionDialog
            chord={chord}
            acceptCB={
                updateChordCB ? (c) => {
                    updateChordCB(c);
                    setChordSelectorRefEl(undefined);
                } : () => setChordSelectorRefEl(undefined)
            }
            discardCB={() => setChordSelectorRefEl(undefined)}
            removeCB={
                updateChordCB ? () => {
                    updateChordCB(undefined);
                    setChordSelectorRefEl(undefined);
                } : () => setChordSelectorRefEl(undefined)
            } />
    </RydFloatingPanel>);
}